import React, { Component } from 'react'

class Index extends Component {
  componentDidMount() {
    // console.log(window)
    window.location.replace('http://monbanquet.fr')
  }
  render() {
    return <div>Redirecting ...</div>
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js